// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xAbMMI4oCusuNKfhunZf{background:linear-gradient(rgba(255,255,255,0) 0%,#fff 14.34%);grid-template-columns:auto auto 1fr auto;gap:8px;padding-top:40px;padding-bottom:64px;display:grid;position:-webkit-sticky;position:sticky;bottom:0}.xAbMMI4oCusuNKfhunZf.UnxwoPzIldMygItgI1Jr{grid-template-columns:1fr}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `xAbMMI4oCusuNKfhunZf`,
	"isTest": `UnxwoPzIldMygItgI1Jr`
};
export default ___CSS_LOADER_EXPORT___;
